<h2 mat-dialog-title>Filtering</h2>
<ng-container *ngIf="data.currentFilter.available">
  <mat-slide-toggle
    [(ngModel)]="current"
    ngDefaultControl
    (change)="setCurrentFilter()"
    >{{ data.currentFilter.filter!.label }}</mat-slide-toggle
  >
</ng-container>
<mat-dialog-content>
  <p class="mat-caption">Available filters</p>
  <mat-chip-list>
    <ng-container *ngFor="let filter of data.filters">
      <mat-chip
        *ngIf="filter.type !== 'current'"
        [value]="filter"
        #chip="matChip"
        (click)="chip.toggleSelected(true); selectFilter(filter)"
        [selected]="filter === newFilter?.filter"
        >{{ filter.label }}</mat-chip
      >
    </ng-container>
  </mat-chip-list>
  <div fxLayout fxLayoutAlign="center center" fxLayoutGap="12px">
    <atm-filter-editor-input
      [data]="newFilter"
      (setFilter)="setFilter($event)"
      (filtering)="addFilter()"
      [disabled]="this.newFilter === null"
    ></atm-filter-editor-input>
    <button
      mat-mini-fab
      type="button"
      color="primary"
      (click)="addFilter()"
      [disabled]="!this.newFilter?.value && !this.newFilter"
    >
      <mat-icon>add</mat-icon>
    </button>
  </div>
  <p class="mat-caption">Setted filters</p>
  <mat-chip-list>
    <ng-container *ngFor="let filter of filtersSetted; let i = index">
      <mat-chip
        (removed)="removeFilter(i)"
        (click)="changeFilter(filter, i)"
        [selected]="i === changedFilter"
      >
        {{ filter | filterLabel }}
        <button matChipRemove *ngIf="filter.filter.removable">
          <mat-icon>cancel</mat-icon>
        </button></mat-chip
      >
    </ng-container>
  </mat-chip-list>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial mat-dialog-close>Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="submit()"
    [disabled]="!newFilterSetted"
  >
    Filter
  </button>
  <span class="mat-caption">Hit CTRL+ENTER to filter</span>
</mat-dialog-actions>
